<template>
  <div class="list-affiliate-sync-page">
    <KTCodePreview v-bind:title="'Trạng thái đồng bộ Affiliate'">
      <template v-slot:preview>
        <!-- Header session -->
        <!-- tag-->
        <b-row class="mb-5">
          <b-col md="3">
            <div class="search-col">
              <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.fromDate"
              ></date-picker>
              <span class="ml-1 mr-1"></span>
              <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.toDate"
              ></date-picker>
            </div>
          </b-col>
          <b-col md="2">
            <b-form-input
              v-model.trim="params.referenceId"
              type="text"
              placeholder="ID tham chiếu"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <b-form-select
              class="text-center"
              value-field="id"
              text-field="name"
              v-model="params.module"
              :options="listAffiliateSyncModule"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Lọc theo module --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col md="2">
            <b-form-select
              class="text-center"
              value-field="id"
              text-field="name"
              v-model="params.errorFrom"
              :options="errorFromOptions"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Lọc theo nguồn lỗi --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col md="2">
            <b-form-select
              class="text-center"
              value-field="id"
              text-field="name"
              v-model="params.status"
              :options="syncStatusOptions"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Trạng thái --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <!--end tag-->
        <b-row class="mb-5">
          <b-col md="1">
            <b-button
              variant="primary"
              size="sm"
              class="btn font-weight-bold btn-size"
              @click="onFilter()"
              :disabled="onLoading"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <b-nav class="my-3" tabs pills> </b-nav>
        <!-- End of Header session -->
        <!-- Table session -->
        <b-table
          :items="listAffiliateSyncStatus"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:cell(status)="row">
            <span
              v-text="STATUS_CODE_NAME[row.item.status]"
              class="label font-weight-bold label-lg label-inline mb-2"
              :class="statusNameClasses(row.item.status)"
              style="width: max-content"
            ></span>
          </template>
          <template v-slot:cell(moduleName)="row">
            <span>{{ syncModuleName[row.item.module] }}</span>
          </template>
          <template v-slot:cell(createdAt)="row">
            <span>{{ formatDate(row.item.createdAt, CLIENT_DATE_TIME) }}</span>
          </template>
          <template v-slot:cell(updatedAt)="row">
            <span>{{ formatDate(row.item.updatedAt, CLIENT_DATE_TIME) }}</span>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i class="flaticon2-settings"></i>
                </template>
                <b-dropdown-item @click="showDetailError(row.item)">
                  <span style="color: #3f4254; font-size: 10px">
                    <i class="flaticon-eye"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item @click="retrySync(row.item)">
                  <span style="color: #3f4254; font-size: 10px">
                    <i
                      style="font-size: 1rem; color: #16610e"
                      class="menu-icon fas fa-sync icon-size"
                    ></i>
                    &nbsp; Đồng bộ lại
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <!-- End of Table session -->

        <!-- Paginate session -->
        <b-row>
          <b-col>
            <p class="mt-3 text-dark font-weight-bold">
              Hiển thị {{ startIndex }} - {{ endIndex }} trong số
              {{ totalItems }} bản ghi
            </p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="totalPages || 1"
              :current-page="page"
              :total-page="totalPages"
              :linkParams="{}"
              @page-change="fetchData()"
            >
            </BPaginationNavCustom>
          </b-col>
        </b-row>
        <!-- End of Paginate session -->
        <b-modal
          ref="error-detail-modal"
          hide-footer
          title="Chi tiết đồng bộ"
          size="lg"
        >
          <v-form>
            <div>
              <p>
                <span class="font-weight-bold">Đường dẫn: </span
                >{{ previewDetail.url }}
              </p>
              <p>
                <span class="font-weight-bold">Phương thức: </span
                ><span
                  class="label label-warning label-inline font-weight-bold"
                  >{{ previewDetail.method }}</span
                >
              </p>
              <p v-if="previewDetail.errorFrom">
                <span class="font-weight-bold">Lỗi từ: </span
                ><span
                  class="label label-light-danger label-inline font-weight-bold"
                  >{{
                    getAffiliateSyncErrorFromName(previewDetail.errorFrom)
                  }}</span
                >
              </p>
              <p v-if="previewDetail.retryCount">
                <span class="font-weight-bold">Số lần thử lại: </span
                ><span class="text-danger font-weight-bold">{{
                  previewDetail.retryCount
                }}</span>
              </p>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Thời gian tạo - cập nhật"
                    label-class="font-weight-bold"
                  >
                    {{ formatDate(previewDetail.createdAt, CLIENT_DATE_TIME) }}
                    <i class="text-dark-75 fa fa-arrows-alt-h mx-2"></i>
                    {{ formatDate(previewDetail.updatedAt, CLIENT_DATE_TIME) }}
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Đầu vào:"
                    label-for="input-json"
                    label-class="font-weight-bold"
                  >
                    <pre id="input-json">{{ previewDetail.payload }}</pre>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="pt-5">
                <b-col md="12">
                  <b-form-group
                    label="Kết quả lần đầu:"
                    label-class="font-weight-bold"
                  >
                    <pre id="input-json">{{ previewDetail.response }}</pre>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="pt-5" v-if="previewDetail.retryResponse">
                <b-col md="12">
                  <b-form-group
                    label="Kết quả thử lại:"
                    label-class="font-weight-bold"
                  >
                    <pre id="input-json">{{ previewDetail.retryResponse }}</pre>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-form-group
                label="Đầu vào thử lại"
                label-for="input-json"
                label-class="font-weight-bold"
                v-if="previewDetail.retryPayload"
              >
                <pre id="input-json">{{ previewDetail.retryPayload }}</pre>
              </b-form-group>

              <div class="text-right">
                <b-button
                  style="width: 70px"
                  variant="primary"
                  size="sm"
                  @click="hideDetailErrorModal"
                  >Đóng</b-button
                >
              </div>
            </div>
          </v-form>
        </b-modal>
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import 'vue-cute-timeline/dist/index.css';
import {
  DP_CONFIG,
  getSubtractDate,
  formatDate,
  CLIENT_DATE_TIME,
} from '@/utils/date';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { STATUS_CODE, AFFILIATE_SYNC_ERROR_FROM } from '@/utils/enum';
import {
  STATUS_CODE_NAME,
  AFFILIATE_SYNC_ERROR_FROM_NAME,
} from '@/utils/enum-name';
import { formatDBDate } from '@/utils/date';
import { pickBy, isNil } from 'lodash';
import { makeToastSuccess, handleError } from '@/utils/common';
import { showConfirmNotify } from '@/utils/sweet-alert2';

export default {
  data() {
    return {
      page: 1,
      limit: 10,
      listAffiliateSyncModule: [],
      errorFromOptions: Object.entries(AFFILIATE_SYNC_ERROR_FROM).map(
        ([key, value]) => ({
          id: value,
          key,
          name: AFFILIATE_SYNC_ERROR_FROM_NAME[value],
        }),
      ),
      onLoading: false,
      listAffiliateSyncStatus: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'referenceId',
          label: 'ID tham chiếu ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'moduleName',
          label: 'Tên module',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'font-weight-bold',
        },
        {
          key: 'responseMessage',
          label: 'Kết quả',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-center',
        },
        {
          key: 'createdAt',
          label: 'Thời gian tạo',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-right',
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
        },
      ],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      dpConfigs: DP_CONFIG,
      params: {
        fromDate: getSubtractDate(15),
        toDate: null,
        status: null,
        module: null,
        referenceId: '',
        errorFrom: null,
      },
      totalItems: 0,
      totalPages: 1,
      CLIENT_DATE_TIME,
      STATUS_CODE_NAME,
      syncStatusOptions: Object.entries(STATUS_CODE).map(([key, value]) => ({
        id: value,
        key,
        name: STATUS_CODE_NAME[value],
      })),
      previewDetail: {},
      syncModuleName: {},
      AFFILIATE_SYNC_ERROR_FROM_NAME,
    };
  },
  methods: {
    formatDate,
    async fetchListAffiliateSyncModule() {
      const {
        data: { data },
      } = await ApiService.get('affiliates/sync/module');
      this.listAffiliateSyncModule = data;
      this.syncModuleName = data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
    },
    async onFilter() {
      this.$route.query.page = 1;
      this.fetchData();
    },
    async fetchData() {
      try {
        if (this.onLoading) return;
        this.onLoading = true;
        const params = this.setParamsFilter();
        const {
          data: { data },
        } = await ApiService.query('affiliates/sync/status', { params });
        this.listAffiliateSyncStatus = data.result;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
      } catch (error) {
        handleError(error);
      } finally {
        this.onLoading = false;
      }
    },
    setParamsFilter() {
      const page = this.$route.query.page || 1;
      return pickBy(
        {
          ...this.params,
          referenceId: this.params.referenceId?.trim() || undefined,
          fromDate: formatDBDate(this.params.fromDate),
          toDate: formatDBDate(this.params.toDate),
          page,
          limit: this.limit,
        },
        (value) => !isNil(value),
      );
    },
    statusNameClasses(status) {
      const statusClassMapping = {
        [STATUS_CODE.ERROR]: 'label-light-danger',
        [STATUS_CODE.SUCCESS]: 'label-light-success',
      };
      return statusClassMapping[status] || 'label-light-info';
    },
    async retrySync(item) {
      try {
        const { isConfirmed } = await showConfirmNotify({
          title: 'Đồng bộ lại',
          text: 'Bạn có chắc muốn đồng bộ lại?',
          actionName: 'Xác nhận',
        });
        if (!isConfirmed) return;
        const {
          data: { data, message },
        } = await ApiService.put(`affiliates/sync/retry/${item.id}`);
        const foundIndex = this.listAffiliateSyncStatus.findIndex(
          ({ id }) => id === item.id,
        );
        Object.assign(this.listAffiliateSyncStatus[foundIndex], data);
        makeToastSuccess(message);
      } catch (error) {
        handleError(error);
      }
    },
    showDetailError(item) {
      this.previewDetail = {
        ...item,
        response: JSON.parse(item.response),
        payload: JSON.parse(item.payload),
        retryResponse: item.retryResponse && JSON.parse(item.retryResponse),
      };
      this.$refs['error-detail-modal'].show();
    },

    hideDetailErrorModal() {
      this.$refs['error-detail-modal'].hide();
    },

    getAffiliateSyncErrorFromName(errorFrom) {
      return AFFILIATE_SYNC_ERROR_FROM_NAME[errorFrom]?.toUpperCase() || '';
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'Danh sách trạng thái đồng bộ Affiliate',
        route: 'affiliate-sync',
      },
      { title: 'Danh sách trạng thái đồng bộ Affiliate' },
    ]);
  },
  created() {
    this.fetchData();
    this.fetchListAffiliateSyncModule();
  },
  computed: {
    startIndex() {
      return (this.page - 1) * this.limit + 1;
    },
    endIndex() {
      return this.page * this.limit;
    },
  },
  components: {
    KTCodePreview,
    VclTable,
    BPaginationNavCustom,
  },
};
</script>

<style scoped>
.btn-size {
  width: 90px;
}

.icon-size {
  font-size: 1rem;
}

.nav .nav-link {
  color: #3f4254;
  font-weight: 800;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

select {
  height: 2.5em;
}

code,
pre {
  margin: 1em 0;
  padding: 1em;
  border: 1px solid #bbb;
  display: block;
  background: #dddddd96;
  border-radius: 3px;
}

.form-group {
  margin-bottom: 1em;
}

.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

.search-col {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss" scoped></style>
